export enum LinkType {
  OPEN_COOKIE_CONSENT_OPTIONS = 'openCookieConsentOptions',
  OPEN_ABBY_CHAT_BOT = 'openAbbyChatBot',
}
